import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RtvCarHotListGridApiServiceOptions {
    odataUrl = `odata/carhotlistgrid`;
    apiUrl = ``;
}
